import { render, staticRenderFns } from "./InputTagDropdownLocation.vue?vue&type=template&id=00b02384&scoped=true"
import script from "./InputTagDropdownLocation.vue?vue&type=script&lang=js"
export * from "./InputTagDropdownLocation.vue?vue&type=script&lang=js"
import style0 from "./InputTagDropdownLocation.vue?vue&type=style&index=0&id=00b02384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b02384",
  null
  
)

export default component.exports